import React, { useCallback, useState } from "react";

import { Divider } from "@material-ui/core";

import { numScenariosOptions } from '../../config/field-check';

import { Scenario } from '.'
import { TitleInput, ImageUpload, NumericInput, Select, PackageImport } from '../EditorFormElements'
import { AttentionText, CustomFeedback } from "../PracticeComponents";
import { FormFieldWrapper } from "../Global";
import { EditorTabs, Stepper } from "../Interface";


export const FieldCheckForm = ({given, ...props}) => {
  const [numScenarios,setNumScenarios] = useState(given.numScenarios || 1);
 
  const onNumScenariosChange = useCallback((name,value) => {
    setNumScenarios(value)
  },[])

  const generalTab = (
    <>
      <PackageImport />

      <FormFieldWrapper>

        <TitleInput
          label="Item Title"
          defaultText="Enter item title"
          given={given.title}
        /> 

      </FormFieldWrapper>

      <FormFieldWrapper halfSizeInputs >

        <Select 
          label="Number of Scenarios"
          name='numScenarios'
          options={numScenariosOptions}
          given={given.numScenarios}
          callback={onNumScenariosChange}
          help="If changed, you will lose content provided for other scenarios."
        /> 

        <NumericInput
          label="Duration (minutes)"
          name="minutes"
          min={0}
          max={120}
          given={given.minutes}
        />

      </FormFieldWrapper>

      <Divider />

      <AttentionText given={given.attention} />
    </>
  )


  const stylesTab = (
    <FormFieldWrapper>
      <ImageUpload 
        label="Instructions Background Image" 
        name="bg"
        tooltip="Upload an image to display as the background of the instructions page. Must be the size 1280 x 998 px and not exceed 150KB."
        given={given.bg}
      />                
    </FormFieldWrapper>
  )

  
  let steps = [];
  for (let i = 0; i < parseInt(numScenarios); i++) {
    steps.push({
      label: `Scenario ${i+ 1}`,
      icon: <span>{i + 1}</span>,
      content: <Scenario 
                index={i}
                numScenarios={numScenarios}
                given={given.scenarios ? given.scenarios[i] : {}}
                path={['scenarios']}
              />
    })
  }
  steps.push({
    label: "Wrap Up",
    icon: <i className="far fa-flag"></i>,
    content: <CustomFeedback given={given.responses} />
  })

  const contentTab = (
    <Stepper
      steps={ steps }
    />
  )

  return (
    <EditorTabs
      general={generalTab}
      styles={stylesTab}
      content={contentTab}
    />
  );
}